import { ImageSourceHelper } from '@sortlist-frontend/media';
import deepmerge from 'deepmerge';
import { generateNextSeo, type NextSeoProps } from 'next-seo/pages';
import Head from 'next/head';

import { usePublicAppContext } from '_core/context/public-app-context';

const defaultSeoImage = ImageSourceHelper.fromPath('/_img/default/default-meta.webp', { width: 1200 });

export type PageSeoTagProps = {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  canonical: string;
  nextSeoProps?: NextSeoProps;
};

export const PageSeoTag = ({
  title,
  description,
  image = defaultSeoImage,
  url,
  canonical,
  nextSeoProps,
}: PageSeoTagProps) => {
  const { domainInfo } = usePublicAppContext();
  const isProduction = domainInfo?.getEnvironment() === 'production';
  const noIndexNoFollow: Partial<NextSeoProps> = isProduction ? {} : { noindex: true, nofollow: true };
  const seoTags = generateNextSeo(
    deepmerge(
      {
        title,
        description,
        canonical,
        openGraph: {
          url,
          title,
          description,
          images: [
            {
              url: image,
            },
          ],
        },
      },
      {
        ...nextSeoProps,
        ...noIndexNoFollow,
      },
    ),
  );

  return <Head>{seoTags}</Head>;
};
